export const mapEventToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const ttsEventColumns = [
  { key: "eventNamespace", label: "Namespace", align: "center" },
  { key: "eventName", label: "Name", align: "center" },
  { key: "type", label: "type", align: "center" },
];
